import React, { Component } from "react";
import _ from "lodash";
import I18n from "../../../../i18n/I18n";
import Icon from "../../../common/Icon";
import Button from "../../../common/button/Button";
import OrderDetailsRow from "../orderDetailsRow/OrderDetailsRow";
import OrderModal from "../orderModal/OrderModal";
import Modal from "../../../common/modal/Modal";
import Helper from "../../../../helper/Helper";
import styles from "./OrderDetailsTable.scss";
import OrderDetailsBox from "../orderDetailsBox/OrderDetailsBox";

class OrderDetailsTable extends Component {
  state: {
    selected: ?Array
  };
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      modalOpen: false
    };
    this.openDetail = this.openDetail.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  openDetail = idOffer => {
    const itemsMerged = this.props.data
      ? Helper.merge(
          this.props.data.items,
          this.props.data.grouped_items,
          "idOffer"
        )
      : [];

    let selected = [];

    for (const index in itemsMerged) {
      if (itemsMerged[index].idOffer === idOffer) {
        selected.push(itemsMerged[index]);
      }
    }
    this.setState({
      selected
    });

    this.openModal();

    // updatedVariants.push(updatedValue);
  };

  openModal() {
    this.setState({
      modalOpen: true
    });
  }

  onCloseModal() {
    this.setState({
      modalOpen: false
    });
  }

  render() {
    const data = this.props.data || "";

    const haveVariant =
      data &&
      data.grouped_items &&
      data.grouped_items.find(order => order && order.variant);

    const orderList =
      data && data.grouped_items
        ? data.grouped_items.map((order, index) => (
            <OrderDetailsRow
              order={order}
              currencyCode={this.props.currencyCode}
              modifiable={this.props.modifiable}
              onQtyChange={this.props.onQtyChange}
              openDetail={this.openDetail}
              haveVariant={haveVariant}
              key={index}
            />
          ))
        : "";

    // Order detail view for mobiles and tabs
    const orderDetailsBox =
      data && data.grouped_items
        ? data.grouped_items.map((order, index) => (
            <OrderDetailsBox
              order={order}
              currencyCode={this.props.currencyCode}
              modifiable={this.props.modifiable}
              onQtyChange={this.props.onQtyChange}
              openDetail={this.openDetail}
              key={index}
            />
          ))
        : "";

    return (
      <div className={styles.ctr}>
        {this.props.browser && this.props.browser.greaterThan.tablet ? (
          <table className={styles.table}>
            <thead>
              <tr className={`${styles.row} ${styles.head}`}>
                <th>{I18n.getText("order-details.name", {}, "Name")}</th>
                <th>{I18n.getText("order-details.item-nr", {}, "Item No.")}</th>

                <th>{I18n.getText("order-details.sku", {}, "SKU")}</th>
                <th>
                  {I18n.getText("order-details.p-sku", {}, "Partner SKU")}
                </th>
                <th>{I18n.getText("order-details.price", {}, "Price")}</th>
                <th>
                  {I18n.getText(
                    "order-details.accepted-qty",
                    {},
                    "Accepted Quantity"
                  )}
                </th>
                <th>{I18n.getText("order-details.units", {}, "Units")}</th>
                <th>
                  {I18n.getText(
                    "order-details.subtotal",
                    {
                      currency: I18n.formatCurrency({
                        currency: this.props.currencyCode
                      })
                    },
                    "Subtotal ({currency})"
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {orderList}
              <tr>
                <td colSpan={6} />
                <td className={styles.subTotal}>
                  {I18n.getText("order-details.sub-total", {}, "Subtotal")}
                </td>
                <td>
                  {I18n.formatCurrency(
                    Helper.formatPrice(
                      this.props.total,
                      this.props.currencyCode
                    )
                  )}
                </td>
              </tr>
              <tr>
                <td className={styles.total} colSpan={8}>
                  {I18n.formatCurrency(
                    Helper.formatPrice(
                      this.props.total,
                      this.props.currencyCode
                    )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <div>
            {orderDetailsBox}
            <div className={styles.bottom}>
              <p>
                {I18n.getText("order-details.sub-total", {}, "Subtotal")}
                :&nbsp;
                {I18n.formatCurrency(
                  Helper.formatPrice(this.props.total, this.props.currencyCode)
                )}
              </p>
              <div className={styles.bottomTotal}>
                {I18n.formatCurrency(
                  Helper.formatPrice(this.props.total, this.props.currencyCode)
                )}
              </div>
            </div>
          </div>
        )}

        <Modal
          contentLabel={"OrderDetails"}
          isOpen={this.state.modalOpen}
          closeModal={() => this.onCloseModal()}
        >
          <OrderModal
            selected={this.state.selected}
            currencyCode={this.props.currencyCode}
          />
        </Modal>
      </div>
    );
  }
}

export default OrderDetailsTable;



// WEBPACK FOOTER //
// ./src/components/orders/orderDetails/orderDetailsTable/OrderDetailsTable.js